import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../supabaseClient";
import QRCode from "react-qr-code";
import { formatDisplayAmount } from "../lib/money";

const Ticket = () => {
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);

  const fetchTicket = useCallback(async () => {
    const { data } = await supabase
      .from("tickets")
      .select(`
        *,
        ticket_tiers (
          name,
          price,
          events (
            title,
            image_url,
            date,
            time,
            venue
          )
        )
      `)
      .eq("id", id)
      .single();

    setTicket(data);
  }, [id]);

  useEffect(() => {
    fetchTicket();
  }, [fetchTicket]);

  if (!ticket) return <div className="text-white p-10">Loading...</div>;

  const event = ticket.ticket_tiers.events;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">

      {/* MODAL */}
      <div className="w-[420px] bg-[#2b2b2b] rounded-xl overflow-hidden shadow-2xl">

        {/* HEADER */}
        <div className="bg-red-600 text-center py-3 font-bold">
          Ticket Details
        </div>

        {/* CONTENT */}
        <div className="p-6 flex flex-col items-center">

          {/* TICKET CARD */}
          <div className="bg-white text-black w-full rounded-xl p-4 shadow-lg">

            {/* LOGO */}
            <div className="text-center font-bold text-xs mb-2">
              ECHO JHAM
            </div>

            {/* TITLE */}
            <div className="text-[10px] font-bold text-center border-b pb-2 mb-2">
              {event.title.toUpperCase()}
            </div>

            {/* DETAILS */}
            <div className="text-[10px] space-y-1">

              <p><b>DATE:</b> {event.date}</p>
              <p><b>TIME:</b> {event.time}</p>
              <p><b>VENUE:</b> {event.venue}</p>

              <p className="mt-2"><b>Ticket Type:</b> {ticket.ticket_tiers.name}</p>

              <p><b>Price:</b> ₱{formatDisplayAmount(ticket.ticket_tiers.price)}</p>

              <p className="mt-2"><b>Code No.:</b> {ticket.qr_code.slice(0, 8)}</p>
            </div>

            {/* QR */}
            <div className="flex justify-center mt-4">
              <QRCode value={ticket.qr_code} style={{ width: 120 }} />
            </div>

            <p className="text-center text-[9px] mt-2">
              {ticket.qr_code}
            </p>

          </div>

          {/* BUTTON */}
          <button
            className="mt-4 bg-red-600 w-full py-2 rounded font-bold hover:bg-red-700"
          >
            Download PDF
          </button>

        </div>
      </div>

    </div>
  );
};

export default Ticket;